import { createReducer, on } from '@ngrx/store';

import { ReceiveOrderAction } from './receive-order.actions';

export const receiveOrderKey = 'receiveOrder';

export interface ReceiveOrderState {
  receiveOrderView: any;
  receiveOrderList: any;
}

export const initialState: ReceiveOrderState = {
  receiveOrderView: null,
  receiveOrderList: null
};

export const receiveOrderReducer = createReducer<ReceiveOrderState>(
  initialState,
  on(ReceiveOrderAction.receiveOrderViewResponse, (state, response) => {
    return { ...state, receiveOrderView: response.response };
  }),
  on(ReceiveOrderAction.receiveOrderListResponse, (state, response) => {
    return { ...state, receiveOrderList: response.response };
  }),
  on(ReceiveOrderAction.receiveOrderClearViewResponse, (state) => {
    return { ...state, receiveOrderView: null };
  }),
  on(ReceiveOrderAction.receiveOrderClearListResponse, (state) => {
    return { ...state, receiveOrderList: null };
  })
);
